/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Sdh_DescriptionInputs */



/**
* | output |
* | --- |
* | "Select the SDH elements you want to remove from the captions" |
*
* @param {Remove_Sdh_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_sdh_description = /** @type {((inputs?: Remove_Sdh_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Sdh_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez les éléments SDH à supprimer des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die SDH-Elemente aus, die Sie aus den Untertiteln entfernen möchten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona gli elementi SDH che vuoi rimuovere dalle didascalie")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите элементы SDH, которые вы хотите удалить из подписей.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione los elementos SDH que desea eliminar de los subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要从字幕中移除的 SDH 元素")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションから削除したいSDH要素を選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन एसडीएच तत्वों का चयन करें जिन्हें आप कैप्शन से हटाना चाहते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione os elementos SDH que deseja remover das legendas.")
	return /** @type {LocalizedString} */ ("Select the SDH elements you want to remove from the captions")
});